import { getSelectedCalendars, getCalendarGroups } from 'owa-calendar-surface-calendars-store';
import { getUserMailboxInfo } from 'owa-client-ids';
import { getUserConfigurationForUser } from 'owa-session-store';
import { updateSelectedCalendars } from 'owa-calendar-module-selected-calendars-user-config';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';
import { getCalendarEntry } from 'owa-calendar-cache';
import {
    lazyEnableWorkView,
    lazyEnableLifeView,
    lazyDisableWorkView,
    lazyDisableLifeView,
} from 'owa-calendar-worklifeviewoption';
import { isConnectedAccount, getOWAConnectedAccounts } from 'owa-accounts-store';

/**
 * Action to persist calendars selection in view state configuration
 * @param userIdentity user to update the configuration for calendar selection
 */
export let persistCalendarsSelection = action('persistCalendarsSelection')(
    async function persistCalendarsSelection(
        userIdentity: string,
        viaShowThisCalendarOnly: boolean = false
    ) {
        // get the userConfiguration from the session store
        const userConfiguration = getUserConfigurationForUser(userIdentity);

        if (!userConfiguration) {
            trace.info(
                '[persistCalendarsSelection] UserConfiguration not yet initialized on client for the given account: ' +
                    userIdentity
            );
            return;
        }

        let selectedCalendarsForUser = getSelectedCalendars().filter(
            calendar => calendar.id.mailboxInfo.userIdentity == userIdentity
        );

        const groupCalendarGroupForUser = getCalendarGroups().filter(
            g =>
                g.id.mailboxInfo.userIdentity == userIdentity &&
                g.id.mailboxInfo.type == 'GroupMailbox'
        );
        if (groupCalendarGroupForUser && groupCalendarGroupForUser.length > 0) {
            // Append the selected group calendars that belong to the parent calendar group that is associated with this account
            selectedCalendarsForUser = selectedCalendarsForUser.concat(
                getSelectedCalendars().filter(
                    calendar =>
                        calendar.id.mailboxInfo.type == 'GroupMailbox' &&
                        getCalendarEntry(calendar).ParentGroupId ==
                            groupCalendarGroupForUser[0].groupId
                )
            );
        }

        const selectedCalendars = selectedCalendarsForUser.map(selectedCalendar => {
            return selectedCalendar.id.id;
        });
        updateSelectedCalendars(selectedCalendars, userIdentity);
        const connectedAccounts = getOWAConnectedAccounts();

        if (connectedAccounts.length > 0) {
            const IsConnectedAccount = isConnectedAccount(userIdentity);

            if (viaShowThisCalendarOnly) {
                // In the case of user executing 'Show this' only during a multi-account scenario,
                // we would remove all the calendars from the logged in account if fired from consumer account and vice versa.
                if (IsConnectedAccount) {
                    updateSelectedCalendars([], getUserMailboxInfo().userIdentity);

                    //Handling the case of multiple connected accounts
                    const otherConnectedAccounts = connectedAccounts.filter(connectedAccount => {
                        return connectedAccount.userIdentity != userIdentity;
                    });
                    otherConnectedAccounts.map(otherConnectedAccount => {
                        updateSelectedCalendars([], otherConnectedAccount.userIdentity);
                    });
                } else {
                    connectedAccounts.map(connectedAccount => {
                        updateSelectedCalendars([], connectedAccount.userIdentity);
                    });
                }
            }

            if (selectedCalendars.length > 0) {
                IsConnectedAccount
                    ? lazyEnableLifeView.importAndExecute()
                    : lazyEnableWorkView.importAndExecute();
            } else {
                IsConnectedAccount
                    ? lazyDisableLifeView.importAndExecute()
                    : lazyDisableWorkView.importAndExecute();
            }
        }
    }
);

export default persistCalendarsSelection;
